import { ApiResponse } from '../../types';

const apiUrl: string = import.meta.env.VITE_ADMIN_URL;

export const guardarAsistencia = (token: string, body: any): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    const requestOptions: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ ...body }),
    };

    fetch(apiUrl + "/recursos-humanos/asistencia/crear", requestOptions)
      .then((res) => res.json())
      .then((data: ApiResponse) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const guardarSolicitud = (token: string, body: any): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    const requestOptions: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ ...body }),
    };

    fetch(apiUrl + "/recursos-humanos/solicitud/crear", requestOptions)
      .then((res) => res.json())
      .then((data: ApiResponse) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
